import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { GrantonomyLogo } from "@/components/g-logo";
import { PublicLayout } from "@/components/public-layout";

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <GrantonomyLogo />
          <p className="mt-8 text-xs font-medium uppercase tracking-widest text-muted-foreground">
            404
          </p>
          <h1 className="mt-2 font-display text-4xl">{t("notFound.title")}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{t("notFound.body")}</p>
          <div className="mt-6">
            <Button asChild>
              <Link to="/">{t("notFound.home")}</Link>
            </Button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
